export const DAYS = [
  { key: "lun", label: "Lunedì", short: "Lun" },
  { key: "mar", label: "Martedì", short: "Mar" },
  { key: "mer", label: "Mercoledì", short: "Mer" },
  { key: "gio", label: "Giovedì", short: "Gio" },
  { key: "ven", label: "Venerdì", short: "Ven" },
];

export const TIMES = [
  "14:30", "15:00", "15:30", "16:00", "16:30",
  "17:00", "17:30", "18:00", "18:30", "19:00",
];

export const STATUS = {
  green: {
    key: "green",
    label: "Disponibile",
    description: "Può frequentare senza problemi",
    bg: "bg-emerald-500",
    bgLight: "bg-emerald-100",
    ring: "ring-emerald-500",
    text: "text-emerald-800",
    border: "border-emerald-500",
    hex: "#16A34A",
  },
  yellow: {
    key: "yellow",
    label: "Scomodo ma fattibile",
    description: "Non è comodo ma posso organizzarmi",
    bg: "bg-amber-400",
    bgLight: "bg-amber-100",
    ring: "ring-amber-400",
    text: "text-amber-800",
    border: "border-amber-400",
    hex: "#EAB308",
  },
  red: {
    key: "red",
    label: "Impossibile",
    description: "Non riesco proprio in questo orario",
    bg: "bg-rose-500",
    bgLight: "bg-rose-100",
    ring: "ring-rose-500",
    text: "text-rose-800",
    border: "border-rose-500",
    hex: "#DC2626",
  },
};

export const STATUS_ORDER = ["green", "yellow", "red"];
